import { navigation, React, variantProvider } from '@/app'
import { TestPanel } from '@/app'
import { ActionIcon } from '@/components'

export const DebugButton = () => {
  const { enabled } = TestPanel.use()

  const onPress = () => {
    navigation.navigate('TestPanel')
  }

  if (!enabled) return

  return <>
    <ActionIcon
      icon='bug'
      onPress={onPress}
      debugName={'Debug Panel button'}
      variants={['bg:primary3']}
      iconProps={{ variants: ['medium'] }}
      css={styles.bugButton}
    />
  </>
}

const styles = variantProvider.createComponentStyle((theme) => ({
  bugButton: {
    ...theme.presets.fixed,
    left: theme.spacing.value(4),
    bottom: theme.spacing.value(4),
    zIndex: 9,
  },
}), true)
